module.exports = require("rc-trigger");


//////////////////
// WEBPACK FOOTER
// external "rc-trigger"
// module id = 3
// module chunks = 0